import { FC, ReactNode, memo } from 'react';
import { Pagination, Select } from 'antd';
import styles from './styles.module.css';

interface Props {
  pageIndex: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number, pageSize: number) => void;
  onPageSizeChange: (value: string) => void;
  pageSizeOptions?: string[];
  centerContent?: ReactNode;
  disabled?: boolean;
}

const DEFAULT_PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];

const TableFooterComponent: FC<Props> = ({
  pageIndex,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  centerContent,
  disabled = false,
}) => {
  const hasCenterContent =
    centerContent !== undefined && centerContent !== null;

  return (
    <div
      className={
        hasCenterContent
          ? `${styles.paginationContainer} ${styles.paginationContainerWithCenter}`
          : styles.paginationContainer
      }
    >
      <Pagination
        style={{ fontSize: 16 }}
        size="small"
        className={styles.pagination}
        current={pageIndex + 1}
        pageSize={pageSize}
        total={total}
        onChange={onPageChange}
        showSizeChanger={false}
        disabled={disabled}
      />
      {hasCenterContent && (
        <div className={styles.centerContent}>{centerContent}</div>
      )}
      <div className={styles.pageSizeSelector}>
        <div className={styles.inputsContainer}>
          <Select
            className={styles.input}
            value={pageSize.toString()}
            onChange={onPageSizeChange}
            style={{ fontSize: 16, color: '#757575' }}
            disabled={disabled}
          >
            {pageSizeOptions.map((size) => (
              <Select.Option key={size} value={size}>
                <span className={styles.inputSpan}>{size}/стр.</span>
              </Select.Option>
            ))}
          </Select>
        </div>
        <span className={styles.totalText}>Всего записей: {total}</span>
      </div>
    </div>
  );
};

export const TableFooter = memo(TableFooterComponent);
TableFooter.displayName = 'TableFooter';
